import React from 'react';
import { motion } from 'framer-motion';
import CountUp from 'react-countup';

const StatsCounter = ({ value, label, suffix = '', prefix = '', color = 'text-primary' }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="text-center p-8 bg-white/80 backdrop-blur-md rounded-2xl shadow-lg border border-white/20"
      data-testid="stats-counter"
    >
      <div className={`text-5xl font-bold ${color} mb-2`} style={{ fontFamily: 'Playfair Display, serif' }}>
        {prefix}
        <CountUp end={value} duration={2.5} separator="," />
        {suffix}
      </div>
      <p className="text-gray-600 text-lg font-medium">{label}</p>
    </motion.div>
  );
};

export default StatsCounter;